module.exports = __webpack_public_path__ + "static/media/user_account_Selected.b3e7e304.svg";